import { LayoutKey } from '@ansyn/map-facade';

export const ContextConfig = 'contextConfig';

export interface IContextConfig {
	TwoMaps: I2MapsContext
}

export enum ContextName {
	AreaAnalysis = 'areaAnalysis',
	QuickSearch = 'QuickSearch',
	ImisightMission = 'ImisightMission',
	TwoMaps = 'TwoMaps'
}

export const RequiredContextParams = {
	[ContextName.AreaAnalysis]: ['geometry'],
	[ContextName.QuickSearch]: ['geometry', 'time', 'sensors'],
	[ContextName.TwoMaps]: ['geometry'],
	[ContextName.ImisightMission]: ['geometry', 'accessToken', 'idToken', 'expiresIn']
};

export interface I2MapsContext {
	layout: LayoutKey,
	sensors: string[]
}
